/* Exemple de classe */
class BaseClass {
	constructor() {

		this.dom = {

		};

		this.init();
	}

	init() {


	}
}
